// extracted by mini-css-extract-plugin
export default {"container":"container__AntXt","main":"main__6Aj+h","page-title":"page-title__PY7ev","disabled-message":"disabled-message__+EfSa","icon":"icon__geR0S"};